import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useInvoicesStore } from "../../store/invoices.store";

export const useInvoices = () => {
  const setInvoices = useInvoicesStore((state) => state.setInvoices);

  return useMutation(PartnerApi.invoices, {
    onSuccess: (data) => {
      setInvoices(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};

export const useInvoicesCompanyDetail = () => {
  const setInvoicesCompanyDetail = useInvoicesStore(
    (state) => state.setInvoicesCompanyDetail
  );

  return useMutation(PartnerApi.invoices, {
    onSuccess: (data) => {
      setInvoicesCompanyDetail(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
